import { ethers } from "ethers";
import { getBlockTimestamp } from "./network";
import { toFixed } from "../number";
import { RouterInputs } from "~/trpc/shared";

export const waitForTransaction = async (
  provider: ethers.JsonRpcApiProvider,
  transactionHash: string,
) => {
  return await provider.waitForTransaction(transactionHash);
};

export const getTransactionHistoryFromReceipt = async (
  provider: ethers.JsonRpcApiProvider,
  receipt: ethers.TransactionReceipt,
  usedGasFee?: number,
): Promise<Partial<RouterInputs["token"]["updateTokenHistory"]>> => {
  const blockTimestamp = await getBlockTimestamp(provider, receipt.blockNumber);

  return {
    status: receipt.status === 1 ? "Complete" : "Fail",
    blockNumber: receipt.blockNumber,
    txTimestamp: new Date(blockTimestamp * 1000),
    usedGasFee:
      usedGasFee ??
      toFixed(ethers.formatEther(receipt.gasUsed * receipt.gasPrice), 18),
  };
};
